<qvs-login-page-header></qvs-login-page-header>
<div class="qvs-registration-qr">
  <p class="qvs-registration-qr__contract-number">
    {{ 'ebanking.login.CONTRACT_NUMBER' | translate }}&nbsp;<span class="qvs-registration-qr__contract-number--secondary">{{
      contractNumber$ | async
    }}</span>
  </p>

  @if (errorContent$ | async; as errorContent) {
    <qvs-registration-error
      [title]="errorContent.title | translate"
      [paragraphOne]="errorContent.paragraphOne | translate"
      [paragraphTwo]="errorContent.paragraphTwo | translate"
      [supportMail]="errorContent.supportMail | translate"
      [supportPhone]="errorContent.supportPhone | translate"
      [buttonText]="errorContent.buttonText | translate"
      (buttonClick)="startNewRegistration()"
    ></qvs-registration-error>
  } @else {
    @if (dataUri$ | async; as qrCode) {
      <img
        class="qvs-registration-qr__image"
        [src]="qrCode"
        [alt]="'registration QR code'"
        [ngClass]="(isRegistrationInProgress$ | async | falsy) ? 'qvs-registration-qr__image-blur' : ''"
      />
    }

    <div class="qvs-registration-qr__description" [style.visibility]="(dataUri$ | async) ? 'visible' : 'hidden'">
      <qvs-svg-icon
        class="qvs-registration-qr__description__icon"
        [src]="descriptionIcon$ | async"
        [title]="'registration-scan-icon'"
      ></qvs-svg-icon>
      <p class="qvs-registration-qr__description__text">{{ description$ | async | translate }}</p>
    </div>
  }
</div>
